import { crmRequest } from '@meta-vue/util'
import { IM_WORKBENCH_MAP, ELE_FORM_ITEM_TYPE } from '@/constant'
// import CallStore from '@/stores/caller'

export default {
  data() {
    return {
      sources: []
    }
  },

  computed: {
    callId() {
      return this.$route?.query?.callId
    }
  },
  watch: {
    callId: {
      handler(callId) {
        const workbenchId = this.$route?.query?.workbenchId
        const { path } = this.$route || {}
        if (callId && +workbenchId === IM_WORKBENCH_MAP.ONLINE_IM && path?.startsWith('/im')) {
          this.getSources(this.callId)
        } else if (callId && +workbenchId === IM_WORKBENCH_MAP.ONLINE_CALL && path?.startsWith('/tr_callin')) {
          // const matchUser = CallStore.state?.in?.find?.(u => u.callId === callId)
          // if (matchUser && matchUser?.imConversationId) this.getSources(matchUser?.imConversationId)
        }
      },
      immediate: true
    }
  },
  methods: {
    async getSources(callId) {
      if (!callId) return
      try {
        // https://dev-apide.amh-group.com/#/interface?app=crm-online-service-app&api=66c737714235cf3eb5069451&fixedId=7f3e9ffe9d3f8f52b6dd72014ba84783
        const list = await crmRequest(
          '/crm-online-service-app/onlineCustomerService/conversationMessage/queryConversationFileMessages',
          {
            method: 'post',
            data: {
              conversationId: callId
            }
          }
        )
        if (Array.isArray(list)) {
          this.sources = list.reduce((prev, item) => {
            if (['img', 'video'].includes(item.fileType)) {
              prev.push({ url: item.content.url, type: item.fileType })
            }
            return prev
          }, [])
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
